module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addcourse addcourseware coursewareModle commonAddcourse manageMeeting"
  }, [_c('div', {
    staticClass: "crumbs"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'EntryPage'
      }
    }
  }, [_vm._v("首页")])], 1), _vm._v(" >\n      "), _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ManageMeeting'
      }
    }
  }, [_vm._v("专题读片")])], 1), _vm._v(" >\n      "), _c('span', [_vm._v("详情")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mp4Show),
      expression: "mp4Show"
    }],
    staticClass: "mp4-area",
    attrs: {
      "id": "mp4"
    }
  }, [_c('div', {
    attrs: {
      "id": "coor"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mp4-head"
  }, [_c('span', [_vm._v(_vm._s(_vm.lessonName))]), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-yichu",
    attrs: {
      "id": "close-mp4"
    },
    on: {
      "click": _vm.closeMp4
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mp4-left"
  }, [_c('ul', _vm._l((_vm.lessonInfo.videoList), function(video, index) {
    return _c('li', {
      key: index,
      class: {
        'play-now': _vm.playIndex == index
      },
      on: {
        "click": function($event) {
          return _vm.playVideo(video, index)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(video.fileName))]), _c('span')])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "mp4-video"
  }, [(_vm.videoShow) ? _c('video', {
    ref: "video",
    attrs: {
      "id": "videoElement",
      "controls": "",
      "autoplay": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.videoSrc,
      "type": "video/ogg"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": _vm.videoSrc,
      "type": "video/mp4"
    }
  }), _vm._v(" "), _vm._m(0)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "querysearch course_query left-area",
    attrs: {
      "id": "drag-left"
    }
  }, [_c('div', {
    attrs: {
      "id": "drag"
    },
    on: {
      "mousedown": _vm.drag,
      "mouseup": _vm.dragup
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "course_top"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('span', {
    staticClass: "manageTitle"
  }, [_vm._v(_vm._s(this.detailList.confName))]), _vm._v(" "), _c('span', {
    staticClass: "managesm"
  }, [_vm._v(_vm._s(this.detailList.openFlag))])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enterCon),
      expression: "enterCon"
    }],
    staticClass: "playback",
    class: {
      'playback': _vm.isA, 'unplayback': !_vm.isA
    },
    on: {
      "click": _vm.inputOrplaybackFun
    }
  }, [_vm._v(_vm._s(_vm.inputOrplayback))])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("主持人：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content"
  }, [_vm._v(_vm._s(this.detailList.confChairName))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("会议时间：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content"
  }, [_vm._v(_vm._s(this.detailList.confTime))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("会议地址：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content"
  }, [_vm._v(_vm._s(this.detailList.confAddress))])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remarkTxt"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("参会人员：")]), _vm._v(" "), _c('div', {
    staticClass: "info_content dif_cont"
  }, _vm._l((_vm.attendL), function(item) {
    return _c('span', [_c('b', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('em', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.attendEm),
        expression: "item.attendEm"
      }]
    }, [_vm._v(_vm._s(item.job))]), _vm._v("，\n            ")])
  }), 0)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.memberCountShow),
      expression: "memberCountShow"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-dropdown', {
    staticClass: "members fr"
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": _vm.memberCount,
      "max": 99
    }
  }, [_vm._v("\n             实际到会\n            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right item"
  })], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.attendList), function(item, index) {
    return _c('el-dropdown-item', {
      key: index,
      attrs: {
        "disabled": ""
      }
    }, [_vm._v(_vm._s(item.docName) + " ")])
  }), 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "tabs-text"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName1),
      callback: function($$v) {
        _vm.activeName1 = $$v
      },
      expression: "activeName1"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "first"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("其他附件(" + _vm._s(_vm.attachList.length) + ")")]), _vm._v(" "), _c('div', {
    ref: "files",
    staticClass: "file-block"
  }, [_c('uploadDetail', {
    attrs: {
      "updateFileList": _vm.updateFileList,
      "updatePicList": _vm.updatePicList
    }
  })], 1)]), _vm._v(" "), _c('el-tab-pane', {
    staticClass: "p-table-text",
    attrs: {
      "name": "second"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("相关影像(" + _vm._s(_vm.studyList.length) + ")")]), _vm._v(" "), _c('p-table', {
    attrs: {
      "operationWidth": _vm.operationWidth,
      "head": _vm.head,
      "data": _vm.data,
      "operation": _vm.operation,
      "autoheight": _vm.autoheight
    },
    on: {
      "_operation": _vm._operation_
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    staticClass: "p-table-text",
    attrs: {
      "name": "third"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("相关病例(" + _vm._s(_vm.caseList.length) + ")")]), _vm._v(" "), _c('p-table', {
    attrs: {
      "head": _vm.headVal,
      "data": _vm.dataVal,
      "operation": _vm.operation2,
      "autoheight": _vm.autoheight
    },
    on: {
      "_operation": _vm._operation2_
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('pops', {
    attrs: {
      "show": _vm.popDetail,
      "title": '病例详情',
      "width": '60%'
    },
    on: {
      "closePop": _vm.closePopDetail
    }
  }, [_c('div', {
    staticClass: "popScore carsePop"
  }, [_c('div', {
    staticClass: "popContent detailCont popTxt"
  }, [_c('el-row', {
    staticClass: "row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("病例名称：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(this.medicDetail.caseName))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("病例分类：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.typeName))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("性别：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(this.medicDetail.caseSex))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("年龄：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(this.medicDetail.caseAge))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("检查类型：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(this.medicDetail.examTypeName))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("检查项目：")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(this.medicDetail.examBodyName))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row changeHeight"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("患者病史：")]), _vm._v(" "), _c('span', {
    staticClass: "content disContent"
  }, [_vm._v(_vm._s(this.medicDetail.history))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row changeHeight"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("影像所见：")]), _vm._v(" "), _c('span', {
    staticClass: "content disContent"
  }, [_vm._v(_vm._s(this.medicDetail.evidence))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row changeHeight"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("诊断结果：")]), _vm._v(" "), _c('span', {
    staticClass: "content disContent"
  }, [_vm._v(_vm._s(this.medicDetail.dianogeResult))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row changeHeight"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("病理结果：")]), _vm._v(" "), _c('span', {
    staticClass: "content disContent"
  }, [_vm._v(_vm._s(this.medicDetail.caseResult))])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [_c('el-button', {
    staticClass: "save",
    on: {
      "click": _vm._savePopDetail
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    staticClass: "cancel",
    on: {
      "click": _vm._cancel
    }
  }, [_vm._v("取消")])], 1)])]), _vm._v(" "), _c('aycanImages', {
    ref: "aycanImages",
    attrs: {
      "hospitalId": _vm.params_image.hospitalId,
      "studyPk": _vm.params_image.studyPk,
      "studyUid": _vm.params_image.studyUid
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('object', {
    attrs: {
      "data": "movie.mp4",
      "width": "320",
      "height": "240"
    }
  }, [_c('embed', {
    attrs: {
      "width": "320",
      "height": "240",
      "src": "movie.swf"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-86d194c6","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/manageMeeting/queryManageMeeting.vue
// module id = 587
// module chunks = 1 2 3 4 5 6 7 8